<template>
  <div>
    <div class="rn_my_tit_1">
      {{ myInfo.seller_nick }}님의 페이지<router-link
        to=""
        @click.native="checkAuth"
        ><img src="@/assets/images/sub/my_edit_ico.png" alt=""
      /></router-link>
    </div>
    <!---->
    <div class="rn_my_empty_30"></div>
    <!---->
    <div class="rn_my_box_1">
      <div class="left">
        <img :src="myImg" @error="replaceImg" alt="" />
      </div>
      <div class="right">
        <ul>
          <!-- <li>
            리뷰거래소 거래 현황
            <router-link to="">
              <img src="@/assets/images/sub/my_right_ico_1.png" alt="" />
            </router-link>
            <p>총 23건</p>
          </li>
          <li>
            우리 회사 신뢰도
            <span>4.0</span>
          </li>
          <li>
            미션완료/지불요청<router-link to=""
              ><img src="@/assets/images/sub/my_right_ico_1.png" alt=""
            /></router-link>
          </li>
          <li>
            리뷰 거래소 가기<router-link to=""
              ><img src="@/assets/images/sub/my_right_ico_1.png" alt=""
            /></router-link>
          </li> -->
        </ul>
      </div>
    </div>
    <!---->
    <div class="rn_my_empty_30"></div>
    <!---->
  </div>
</template>

<script>
import check from "@/mixin/checkAuth.js";
export default {
  props: {
    myInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [check],
  computed: {
    myImg() {
      return this.myInfo.seller_img
        ? `${process.env.VUE_APP_API_URL}${this.myInfo.seller_img}`
        : "";
    },
  },
  methods: {
    replaceImg(e) {
      e.target.src = require("@/assets/images/noimage.gif");
    },
    won(str) {
      return this.$won(str);
    },
  },
};
</script>

<style></style>
